var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCirclesFour = function SvgIconCirclesFour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.938 2.75a4.188 4.188 0 1 0 0 8.375 4.188 4.188 0 0 0 0-8.375M4.75 6.938a2.188 2.188 0 1 1 4.375 0 2.188 2.188 0 0 1-4.375 0M17.063 2.75a4.187 4.187 0 1 0 0 8.375 4.187 4.187 0 0 0 0-8.375m-2.188 4.188a2.188 2.188 0 1 1 4.375 0 2.188 2.188 0 0 1-4.375 0M2.75 17.063a4.187 4.187 0 1 1 8.375 0 4.187 4.187 0 0 1-8.375 0m4.188-2.188a2.188 2.188 0 1 0 0 4.375 2.188 2.188 0 0 0 0-4.375M17.063 12.875a4.187 4.187 0 1 0 0 8.375 4.187 4.187 0 0 0 0-8.375m-2.188 4.188a2.188 2.188 0 1 1 4.375 0 2.188 2.188 0 0 1-4.375 0"
  }))));
};
export default SvgIconCirclesFour;